interface BondInfoHeaderProps {
  name: string;
  type: string;
}

export default function BondInfoHeader({ name, type }: BondInfoHeaderProps) {
  return (
    <div className="bond-info-header">
      <div className="bond-info-content-row">
        <div className="bond-info-content">
          <h2>{name || 'Wybierz typ obligacji'}</h2>
          {type && <span className="bond-type-badge">{type}</span>}
        </div>
      </div>
    </div>
  );
} 